import { ReactionType } from '../../../../generated/graphql';

export function getEmojiForReaction(type: ReactionType): string {
  const reactionTypeEmojiMap: Record<ReactionType, string> = {
    CheckMark: '✅',
    Clap: '👏',
    Comment: 'Comment',
    Cry: '😭',
    Disappointed: '😔',
    ExplodingHead: '🤯',
    Eyes: '👀',
    FaceHearts: '🥰',
    Fire: '🔥',
    Fist: '👊',
    Goat: '🐐',
    Heart: '❤️',
    HeartEyes: '😍',
    Horns: '🤟',
    Hug: '🤗',
    Joy: '😂',
    Muscle: '💪',
    OpenMouth: '😮',
    Pray: '🙏',
    RaisedHands: '🙌',
    Relieved: '😌',
    Rocket: '🚀',
    Skull: '💀',
    Sparkles: '✨',
    SweatSmile: '😅',
    Tada: '🎉',
    Tear: '🥲',
    ThumbsUp: '👍',
    Trophy: '🏆',
  };

  return reactionTypeEmojiMap[type] ?? null;
}
